import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { MachineModuleService } from '../../../shared/services';
import { Client } from '../../../shared/models';
import { LocalEntityService } from '../../../shared/services/index';
import { CustomerSelectorPluginService } from '../../../plugins/customerselector/customerselector-plugin.service';
import * as _ from 'lodash';

@Component({
  templateUrl: './edit-customer.component.html',
  standalone: false
})
export class EditCustomerPageComponent extends BaseModalPageComponent implements OnInit {
  public processing = false;
  public customer: Client;
  public languages: any = [];
  public countries: any = [];
  public localEntities: any = [];

  constructor(
    location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private customersService: MachineModuleService,
    private localEntityService: LocalEntityService,
    private pluginService: CustomerSelectorPluginService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const clientNumber = params['clientNumber'];
      this.customersService.getCustomer(clientNumber).subscribe((customer) => {
        this.customer = customer;
        this.initData();
      });
    });
  }

  initData(): void {
    this.languages = _.orderBy(this.pluginService.getLanguages(), ['label']);

    this.pluginService.getCountries().subscribe((data: any) => {
      this.countries = _.orderBy(data, ['label']);
      this.localEntityService.getLocalEntities().subscribe((localEntities: any) => {
        this.localEntities = _.orderBy(localEntities, ['label']);
      });
    });
  }

  update(customer: Client): void {
    this.processing = true;
    this.customersService.updateCustomer(this.customer.clientNumber, customer).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  goToBack() {
    this.router.navigate([this.appRoute, 'customers', this.customer.clientNumber]);
  }
}
